// store/refreshSlice.js
import { createSlice } from '@reduxjs/toolkit';

export const refreshSlice = createSlice({
  name: 'refresh',
  initialState: {
    trigger: 0, // can be timestamp, number, etc.
  },
  reducers: {
    refresh: (state) => {
      state.trigger = Date.now(); // unique value to force re-render
    },
  },
});

export const { refresh } = refreshSlice.actions;
export default refreshSlice.reducer;